
const digest = '256f0d4ee902cddabaa59e3c179ffcd1356055c97493353f3fc3684108a1b096';
const classes = {"assignButton":"_assignButton_z2r6b_1"};
const css = `._assignButton_z2r6b_1 {
  font-size: 12px;
  text-align: left;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  